export enum UserRoles{
    ADMINISTRATOR = "Administrator" , 
    OFFICER = "Officer" , 
    ARCHIVIST = "Archivist", 
}


